import { Const } from '../lib/const.cls'

export const mutations = {
	[Const.SET_REGISTER_DISEASE_LIST](state, data) {
        try { state.diseaseList = data } catch (ex) { console.debug('set state EX', ex) }
    },
    //=======prescription
    [Const.SET_PATIENT_PRESCRIPTION_LIST](state, data) {
        try { state.prescriptionList = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_PATIENT_PRESCRIPTION_DETAIL](state, data) {
        try { state.prescriptionView = data } catch (ex) { console.debug('set state EX', ex) }
    },

    //=========test-report
    [Const.SET_PATIENT_TEST_REPORT_LIST](state, data) {
        try { state.testReportList = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_PATIENT_TEST_REPORT_DETAIL](state, data) {
        try { state.testReportDetail = data } catch (ex) { console.debug('set state EX', ex) }
    },

    //========apponitment
    [Const.SET_APPOINTMENT_LIST](state, data) {
        try { state.appointmentList = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_APPOINTMENT_DETAIL](state, data) {
        try { state.appointmentDetail = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_APPOINTMENT_INFO](state, data) {
        try { state.appointmentInfo = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_AVAILABLE_SLOTS_LIST](state, data) {
        try { state.totalSlotList = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_BUSY_SLOT_LIST](state, data) {
        try { state.busySlotList = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_PATIENT_BUSY_SLOT](state, data) {
        try { state.patientBusySlot = data } catch (ex) { console.debug('set state EX', ex) }
    },

    //=============obt call
    [Const.SET_CHECK_OBT_CALL](state, data) {
        try { state.checkObtCall = data } catch (ex) { console.debug('set state EX', ex) }
    },
    
     //========notification
    [Const.SET_NOTIFICATION_LIST](state, data) {
        try { state.notificationList = data } catch (ex) { console.debug('set state EX', ex) }
    },

    [Const.SET_INITIAL_DATA](state, data) {
        try { state.initialData = data } catch (ex) { console.debug('set state EX', ex) }
    },

    [Const.SET_CHART_DATA](state, data) {
        try { state.chartData = data } catch (ex) { console.debug('set state EX', ex) }
    },

    [Const.SET_MEDICINE_LIST](state, data) {
        try { state.medicineList = data } catch (ex) { console.debug('set state EX', ex) }
    },

    [Const.SET_TASK_ACTION_LIST](state, data) {
        try { state.taskActionList = data } catch (ex) { console.debug('set state EX', ex) }
    }
}



// WEBPACK FOOTER //
// ./src/plugins/Gini/provider/candle-history/store-addons/mutations.js